import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { SdtService } from 'src/app/services/sdt.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { RestService } from 'src/app/services/rest-service';
import { ToastrService } from 'ngx-toastr';
import { SpinnerService } from 'src/app/components/spinner-component/spinner.service';
import { AppSettings } from 'src/app/shared/app-settings';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs/internal/Subscription';


@Component({
  selector: 'app-sdt-details',
  templateUrl: './sdt-details.component.html',
  styleUrls: ['./sdt-details.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MatSelectModule, MatFormFieldModule, MatInputModule, MatButtonModule, MatDatepickerModule, MatNativeDateModule]
})
export class SdtDetailsComponent implements OnInit,OnDestroy  {
  isDataReady = false;
  currentuser;
  username: string;
  selectedDevice: any[];
  readOnlyUser: boolean;
  minDate = new Date();
  formData;
  devices;
  sdtStartDate;
  sdtEndDate;
  createdBy;
  createdAt: any;
  dateForm;
  sdtReason;
  sdtDevices: any
  Response: any;
  loading: boolean;
  completeData: any
  viewdevices;
  deviceData = [];

  dbData: any;
  minDateFrom: any;
  start: any;
  end: any;
  reason: any;
  createdby: void;
  createdat: void;
  uqId: any;
  allDevices: Array<any> = [];
  deviceNames;
  updateReady = false;
  ToDateMaxDate = new Date();
  previousDate: any;
  updatedAt: string;
  sentData: any;
  updatedBy: any;
  editClicked = true;
  serUpdateBy: any;
  serUpdateAt: any;
  result: string = '';
  createdByDetail: string;
  updatedByDetail: string;
  deleteDeviceIds = [];
  thistory: string = null;
  selectedOption = null;
  public showDialog: boolean = false;
  thistorydata: Array<any> = [];
  zenurl: string;
  turl: string;
  siteUnitId;
  ticketId;
  siteType;
  accId;

  private dataSubscription: Subscription;
  private sdtGetsubscription: Subscription;
  private ticketHistorySubscription: Subscription;
  private viewTicketSubscription: Subscription;
  private updateSubscription: Subscription;
  modifiedReason: any;
  reasonTag: any;
  reasonChanged: boolean = false;
  otherReason: string;

  constructor(
    private titleService: Title,
    private http: HttpClient, private sdtService: SdtService, private router: Router, public authService: AuthenticationService,
    public restService: RestService,
    public spinner: SpinnerService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    public dialog: MatDialog,
  ) {
    this.minDate = new Date(),
    this.sdtDevices = this.sdtService.selectedDevices
    this.sdtService.createdBy = this.createdBy
    this.sdtService.updatedBy = this.updatedBy
    if(this.sdtDevices && this.sdtDevices.length > 0){
    this.devices = this.sdtDevices.map(ele => ele.deviceName).filter(deviceName => deviceName)
    }
    this.titleService.setTitle("SDT Detail");
    this.createdBy = this.sdtService.createdBy;
    let dbData=this.sdtService.DBdata;
    if (dbData == undefined) {
      this.getDbData();
    } else {
      this.init()
    }
  }

  reasonForm = new FormGroup({
    sdtReason: new FormControl('', Validators.required),
    otherReason: new FormControl('', [Validators.maxLength(40)])
  });

  getEmails(){
    this.currentuser = this.authService.currentUserValue;
    if (this.currentuser) {
      this.username = this.currentuser.firstName;
      this.sdtService.formData.createdBy = this.currentuser.email;
      this.sdtService.formData.updatedBy = this.currentuser.email
    }
  }
  init() {
    this.getEmails();
    this.dbData = this.sdtService.DBdata;
    this.createdByDetail = this.sdtService.formData.createdBy;
    this.updatedByDetail = this.sdtService.formData.updatedBy;
    this.createdAt = this.sdtService.createdAt
    this.sdtReason = this.sdtService.sdtReason

    let deviceUq = this.route.snapshot.paramMap.get('device')
    this.getSavedDevices(deviceUq)

    this.completeData = this.dbData?.filter(ele => ele.deviceUniqueId == deviceUq)

    for (const item of (this.completeData)) {
      if (item) {
        this.viewdevices = item
      }
    }
  }
  getSavedDevices(device) {
    let currentDevice = this.sdtService.DBdata?.filter(ele => ele.deviceUniqueId == device)

    for (let i = 0; i < currentDevice?.length; i++) {
      this.siteUnitId = currentDevice[i].siteUnitId
      this.ticketId = currentDevice[i].ticketId
      this.accId = currentDevice[i].accId
      this.siteType = currentDevice[i].siteType
    }

    let url = AppSettings.API_ENDPOINT + '/' + AppSettings.VIEW_SDT + 'siteUnitId=' + this.siteUnitId + '&ticketId=' + this.ticketId


    this.dataSubscription = this.http.get(url).subscribe(res => {
      if(res.hasOwnProperty('data') && res['data'] !== null){
      let data = res['data'];
      this.allDevices = res['data'];
      if (data && data.length > 0 && data !== undefined && data !== null) {
        for (let i = 0; i < data.length; i++) {

          switch(data[i].sdtReason) {
            case 'customer_internet':
              data[i].sdtReason = 'Customer Internet';
              break;
            case 'customer_owned_equipment':
              data[i].sdtReason = 'Customer Owned Equipment';
              break;
            case 'customer_power':
              data[i].sdtReason = 'Customer Power';
              break;
            case 'customer_renovations':
              data[i].sdtReason = 'Customer Renovations';
              break;
            case 'customer_request':
              data[i].sdtReason = 'Customer Request';
              break;
            case 'customer_success_sdt':
              data[i].sdtReason = 'Customer Success';
              break;
            case 'natural_disaster':
              data[i].sdtReason = 'Natural Disaster';
              break;
            case 'other_scheduled_downtime_reason':
              data[i].sdtReason = data[i].sdtSubReason;
              break;
            case 'project_management_sdt':
              data[i].sdtReason = 'Project Management';
              break;
            case 'relocation_sdt':
              data[i].sdtReason = 'Relocation';
              break;
            case 'collections_sdt':
              data[i].sdtReason = 'Collections';
              break;
            case 'pending_removal':
              data[i].sdtReason = 'Pending Removal';
              break;
            case 'service_paused':
                data[i].sdtReason = 'Service Paused';
              break;  
          }

        if(data){
          var obj = {
            deviceName: data[i].deviceName,
            uqId: data[i].deviceUniqueId,
            startDate: data[i].sdtStartDate,
            endDate: data[i].sdtEndDate,
            deviceId: data[i].deviceId,
            reason: data[i].sdtReason ? data[i].sdtReason : 'N/A' ,
            selected: false
          }
          this.deviceData.push(obj)
          }
        }
      }
      this.previousDate = data[0]['sdtEndDate'];
      if(this.deviceData.length==0){
        this.router.navigateByUrl('/monitors/');
        this.spinner.deactivate();
        this.loading = false;
      } } else {
        this.loading = false;
        this.toastr.error('Data not found');
      }
    },(err) => {
      this.spinner.deactivate();
      this.loading = false;
    if (err && err.error && err.error.message && err.error.message.length > 0) {
      this.toastr.error(err.error.message, 'Error');
    } else {
      this.toastr.error('Session Expired Please login again.', 'Error');
    }
  }
    )
  }
  ngOnInit(): void {
    this.deviceData
    this.sdtService.selectedDevices = this.devices;
    this.sdtService.createdBy = this.createdBy;
    let title = this.titleService.getTitle();
    this.sdtService.sdtReason = this.sdtReason;
    this.createdByDetail = this.sdtService.formData.createdBy;
    this.updatedByDetail = this.sdtService.formData.updatedBy;
    this.updatedBy = this.sdtService.updatedBy;
    this.updatedAt = this.sdtService.updatedAt;
    this.currentuser = this.authService.currentUserValue;
    if (this.currentuser) {
      this.username = this.currentuser.firstName;
      this.selectedDevice = this.sdtService.selectedDevices;
      if (this.currentuser['privileges'] && this.currentuser['privileges'].length > 0) {
        for (let i = 0; i < this.currentuser['privileges'].length; i++) {
          if (this.currentuser['privileges'][i].toLowerCase() === 'view sdtdetails') {
            this.readOnlyUser = true;
          }
        }
      }
    }

    this.dateForm = new FormGroup({
      'sdtStartDate': new FormControl(null, Validators.required),
      'sdtEndDate': new FormControl(null, Validators.required)
    })

    setTimeout(()=>{
      this.viewTicket()
    },1000)
  }

  onDateChange(evt): void {
    if (this.datePipe.transform((evt.value), 'yyyy-MM-dd') != this.previousDate) {
      this.updateReady = true
    } else {
      this.updateReady = false;
    }
  }

  viewTicket() {
        this.turl = `${AppSettings.API_ENDPOINT}/${AppSettings.VIEW_TICKET}${this.ticketId}`;
        this.viewTicketSubscription = this.http.get(this.turl).subscribe((response:any)=>{
          this.zenurl = response?.ticketUrl;
          if(this.zenurl){
          this.isDataReady = true;
          } else {
          this.isDataReady = false;
          }
        })
  }

  
  edit() {
    this.editClicked = !this.editClicked
  }

  cancel(){
    this.router.navigateByUrl('/monitors/');
  }

  hideIcon(): boolean {
    return !this.deviceData.some(device => device.reason === 'Service Paused');
  }

  reasonsList: any = [
    'Customer Internet',
    'Customer Owned Equipment',
    'Customer Power',
    'Customer Renovations',
    'Customer Request',
    'Customer Success',
    'Collections',
    'Project Management',
    'Relocation',
    'Natural Disaster',
    'Service Paused',
    'Pending Removal',
    'Other'
  ]

  changeReason(e) {
    this.sdtReason = e.value;
    this.modifiedReason;
    switch (e.value) {
      case 'Customer Internet':
        this.modifiedReason = 'customer_internet';
        break;
      case 'Customer Owned Equipment':
        this.modifiedReason = 'customer_owned_equipment';
        break;
      case 'Customer Power':
        this.modifiedReason = 'customer_power';
        break;
      case 'Customer Renovations':
        this.modifiedReason = 'customer_renovations';
        break;
      case 'Customer Request':
        this.modifiedReason = 'customer_request';
        break;
      case 'Customer Success':
        this.modifiedReason = 'customer_success_sdt';
        break;
      case 'Collections':
        this.modifiedReason = 'collections_sdt';
        break;      
      case 'Project Management':
        this.modifiedReason = 'project_management_sdt';
        break;
      case 'Relocation':
        this.modifiedReason = 'relocation_sdt';
        break;
      case 'Natural Disaster':
        this.modifiedReason = 'natural_disaster';
          break;
      case 'Service Paused':
        this.modifiedReason = 'service_paused';
          break;
      case 'Pending Removal':
        this.modifiedReason = 'pending_removal';
          break;
      case 'Other':
        this.modifiedReason = 'other_scheduled_downtime_reason';
          break;  
    }

    this.reasonTag  = this.modifiedReason;
  }

  confirmSelection() {
      this.sdtReason = this.reasonForm.value.sdtReason,
      this.otherReason = this.reasonTag === 'other_scheduled_downtime_reason' ? this.reasonForm.value.otherReason : undefined
      this.reasonChanged = true;
      this.showDialog = false;
      this.updateReady = true;
  }

  /**
   * Delete existed devices from list
   */
  async delete(deviceName: string,id: number) {
    this.updateReady=true;
    this.sdtService.openConfirmDialog('Are you sure to delete?')
      .afterClosed().subscribe(res => {
        if (res) {
          this.deviceData[id]['selected'] = true;
        } else {
          this.deviceData[id]['selected'] = false;
        }
      })
  }

  /**
   * Update data
   * call api to update with remaining devices
   */
  updateData() {
    this.updateSubscription = this.sdtService.openConfirmDialog('Are you sure to update?')
      .afterClosed().subscribe(res => {
        if (res) {
          this.spinner.activate();
          this.loading = true;
          let date = new Date();
          let devids = [];
          this.updatedBy = this.currentuser.email;
          this.updatedAt = this.datePipe.transform(new Date().toLocaleString("en-US", { timeZone: "UTC" }),'MM-dd-yyyy, HH:mm:ss');

          for (let i = 0; i < this.deviceData.length; i++) {
                       if (!this.deviceData[i]['selected']) {
                         devids.push(this.deviceData[i]['deviceId']);
                       } else {
                        this.deleteDeviceIds.push(this.deviceData[i]['deviceId']);
                     }
                    }
          this.sentData = {
            "accId": this.accId,
            "siteType": this.siteType,
            "deviceId": devids,
            "siteUnitId": this.siteUnitId,
            "ticketId": this.ticketId,
            "sdtEndDate": this.datePipe.transform(this.viewdevices.sdtEndDate, 'MM-dd-yyyy'),
            "updatedBy": this.updatedBy,
            "updatedAt": this.updatedAt,
            "sdtReason" : this.reasonTag,
            "sdtSubReason" : (this.reasonTag == 'other_scheduled_downtime_reason') ? this.otherReason : undefined,
            "deleteDeviceIds":this.deleteDeviceIds
          };
          this.restService.putRequest(AppSettings.SDTUPDATE, this.sentData).subscribe((response) => {
            if (response) {
              this.toastr.success((response['messages'] && response['messages'][0]) ? response['messages'][0] : 'UPDATED SUCCESSFULLY', '');
              this.router.navigateByUrl('/monitors/');
            }
            this.spinner.deactivate();
            this.loading = false;
          }, (err) => {
            this.spinner.deactivate();
            this.loading = false;
            if (err && err.error && err.error.message && err.error.message.length > 0) {
              this.toastr.error('Session Expired Please login again.', 'Error');
            } else {
              this.toastr.error('Session Expired Please login again.', 'Error');
            }
          });
        }
      })
  }
  getDbData() {
    this.sdtGetsubscription = this.restService.getRequest(AppSettings.SDTGET, '').subscribe((response) => {
      let sdtDevices = response.data;
      this.sdtService.DBdata = sdtDevices;
      this.dbData = sdtDevices;
      this.init()
    })
  }

  toggleDialog() {
    this.reasonChanged = false;
    this.showDialog = true;
  }

  closeDialog(){
    this.showDialog = false;
  }

  getTicketHistory() {
    let url = AppSettings.TICKETHISTORY + this.thistory;
    this.thistorydata = [];
    this.ticketHistorySubscription = this.restService.getData(url).subscribe((response) => {
      if (response) {
        this.thistorydata = response;
      }
      this.spinner.deactivate();
      this.loading = false;
    }, (err) => {
      this.spinner.deactivate();
      this.loading = false;
      if (err && err.error && err.error.message && err.error.message.length > 0) {
        this.toastr.error(err.error.message, 'Error');
      } else {
        this.toastr.error('Session Expired Please login again.', 'Error');
      }
    });
  }

  getFormattedTicketUrl(ticketUrl: string): string {
    if (ticketUrl.includes('.json')) {
      if (ticketUrl.includes('pro-vigil')) {
        const ticketNumber = ticketUrl.split('/').pop()?.split('.')[0];
        return `https://pro-vigil.zendesk.com/agent/tickets/${ticketNumber}`;
      } else if (ticketUrl.includes('provigil1666630349')) {
        const ticketNumber = ticketUrl.split('/').pop()?.split('.')[0];
        return `https://provigil1666630349.zendesk.com/agent/tickets/${ticketNumber}`;
      }
    }
    return ticketUrl;
  }
  
  ngOnDestroy(): void {
    if (this.dataSubscription) {
      this.dataSubscription.unsubscribe();
    }
    if(this.sdtGetsubscription){
      this.sdtGetsubscription.unsubscribe();
    }
    if(this.ticketHistorySubscription){
      this.ticketHistorySubscription.unsubscribe();
    }
    if(this.viewTicketSubscription){
      this.viewTicketSubscription.unsubscribe();
    }
    if(this.updateSubscription){
      this.updateSubscription.unsubscribe();
    }
  }

}
